import { MessageStroke16 } from '@cian/ui-kit/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Utility } from '../../components/Utility';
import { IApplicationState } from '../../types/redux';

export const UtilityMessagesContainer: React.FC = () => {
  const messagesLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.messages);
  const messagesCount = useSelector<IApplicationState, number>(state => state.messages.count);

  if (!messagesLink) {
    return null;
  }

  return <Utility title="Сообщения" unread={Boolean(messagesCount)} icon={MessageStroke16} href={messagesLink} />;
};
